import {
  LOGIN_REQUEST,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
} from "../states/loginState";

import axios from "axios";
const LoginUser = (data) => {
  // const router = useRouter();
  return async (dispatch) => {
    dispatch({
      type: LOGIN_REQUEST,
    });
    try {
      const response = await axios({
        method: "POST",
        url: "/api/v1/userLogin",
        data: {
          ...data,
        },
      });
      if (response.status === 200) {
        if (response.data) {
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${response.data.data.token}`;
          dispatch({
            type: LOGIN_SUCCESS,
            payload: response.data,
          });
        } else {
          dispatch({
            type: LOGIN_FAILED,
            payload: response.data.data.message,
          });
        }
        // router.push("/user/p2p");
      } else {
        dispatch({
          type: LOGIN_FAILED,
          payload: response.data.data.message,
        });
      }
    } catch (error) {
      console.log("error", error);
      if (error.response.status === 400) {
        var err_400 = error?.response?.data?.message;
        dispatch({
          type: LOGIN_FAILED,
          payload: err_400,
        });
      } else if (error.response.status === 401) {
        const err_401 = error?.response?.data?.message;
        dispatch({
          type: LOGIN_FAILED,
          payload: err_401,
        });
      } else if (error.response.status === 404) {
        const err_404 = error?.response?.data?.message;
        dispatch({
          type: LOGIN_FAILED,
          payload: err_404,
        });
      } else if (error.response.status === 500) {
        const err_500 = error?.response?.data?.message;
        dispatch({
          type: LOGIN_FAILED,
          payload: err_500,
        });
      } else {
        dispatch({
          type: LOGIN_FAILED,
          payload: "something went wrong",
        });
      }
    }
  };
};
export default LoginUser;
